module.exports = __webpack_public_path__ + "static/media/unimed-ibitinga.16b2fa46.png";